import { ShieldPlusOutlineIcon } from './ShieldPlusOutlineIcon';

/**
 * author: Google
 * id 4348C9BA-B7EE-4DC9-9B75-102726C978F7
 * name shield-plus-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-plus-outline.svg
 * tags
 */
export const ShieldAddOutlineIcon = ShieldPlusOutlineIcon;
export default ShieldAddOutlineIcon